import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'

import './css/style.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

Vue.config.productionTip = false

Vue.use(VTooltip)

new Vue({
  render: h => h(App),
}).$mount('#app')
